export default __webpack_public_path__ + "static/media/ies_logo.e0ffe4fe.png";